import { render, staticRenderFns } from "./ParentingTime.vue?vue&type=template&id=33446b49"
import script from "./ParentingTime.vue?vue&type=script&lang=ts"
export * from "./ParentingTime.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports